import { fork } from 'redux-saga/effects';
import { buttonsWatcher } from "./profileButtonsSaga";

export default function* ControlPanelSaga() {
    yield fork(buttonsWatcher)
}
